'use client';

import NextImage from 'next/image';

import { buildImageBypassRules } from '@vs-shop/image-link/imageBypassRules';
import { makeVsImage } from '@vs-shop/image-link/makeVsImage';

import { imageOrigins } from '@rcprofi/config/imageOrigins';
import { getImageBackendFallbackOptionSync } from '@vs-shop/engine/image/getImageBackendFallback';
import { BACKEND_RESOLVE_PATH_PREFIX } from '@vs-shop/engine/image/imageOrigins';

/**
 * rcprofi's smart image, the target of the `@vs-shop/image-link/Image` seam
 * alias. `makeVsImage` holds the behaviour; this module supplies `next/image`
 * and rcprofi's data. `VsImage.tst.ts` pins the prop contract.
 */
export default makeVsImage({
  Image: NextImage,
  // The env-derived rules come first (see @rcprofi/config/imageOrigins). The
  // static rules are hosts no env names — local development, the office server,
  // third parties — plus the production pair, which stays spelled out as the
  // no-env floor.
  bypassRules: buildImageBypassRules({
    origins: imageOrigins,
    backendResolvePathPrefix: BACKEND_RESOLVE_PATH_PREFIX,
    staticRules: [
      { host: 'data.rcprofi.com' },
      { host: 'dev.data.rcprofi.com' },
      { host: 'system.rcprofi.com', pathPrefix: BACKEND_RESOLVE_PATH_PREFIX },
      { host: '192.168.168.77', pathPrefix: BACKEND_RESOLVE_PATH_PREFIX },
      { host: 'localhost', pathPrefix: BACKEND_RESOLVE_PATH_PREFIX },
      { host: 'img.youtube.com' },
    ],
  }),
  resolveFallback: getImageBackendFallbackOptionSync,
});
